export enum OrderStatusEnum {
    ONE = 'enums.orderStatus.onGoing',
    TWO = 'enums.orderStatus.closed',
    THREE = 'enums.orderStatus.cancelled',
    FOUR = 'enums.orderStatus.delay',
    FIVE = 'enums.orderStatus.delayOk',
    SIX = 'enums.orderStatus.deleted'
}
